const FOCUSABLE =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export default function registerModal(Alpine) {
  Alpine.data("modal", (modalId) => ({
    open: false,
    modalId,
    previouslyFocused: null,

    init() {
      this._openHandler = (event) => {
        if (event.detail === this.modalId || event.detail?.id === this.modalId) {
          this.show();
        }
      };
      this._closeHandler = (event) => {
        if (event.detail === this.modalId || event.detail?.id === this.modalId) {
          this.hide();
        }
      };

      window.addEventListener("open-modal", this._openHandler);
      window.addEventListener("close-modal", this._closeHandler);
    },

    destroy() {
      window.removeEventListener("open-modal", this._openHandler);
      window.removeEventListener("close-modal", this._closeHandler);
      // A modal removed while open (e.g. its Turbo frame re-rendered after a
      // submit) would otherwise leave the page scroll-locked, and focus on nothing.
      if (!this.open) return;
      document.body.style.overflow = "";
      if (document.activeElement === document.body) this.returnFocus();
    },

    show() {
      this.previouslyFocused = document.activeElement;
      this.open = true;
      document.body.style.overflow = "hidden";

      this.focusWhenShown();
    },

    // x-show puts a transition's element on screen a frame or two after open flips,
    // and focus() does nothing to a hidden element, so keep trying until it lands.
    focusWhenShown(frames = 10) {
      requestAnimationFrame(() => {
        const dialog = this.$refs.dialog;
        if (!this.open || !dialog || dialog.contains(document.activeElement)) return;

        const focusable = dialog.querySelector(FOCUSABLE);
        focusable?.focus();
        if (focusable && document.activeElement !== focusable && frames > 0) this.focusWhenShown(frames - 1);
      });
    },

    hide() {
      this.open = false;
      document.body.style.overflow = "";

      this.returnFocus();
    },

    returnFocus() {
      if (this.previouslyFocused?.isConnected && typeof this.previouslyFocused.focus === "function") {
        this.previouslyFocused.focus();
      }
      this.previouslyFocused = null;
    },

    handleKeydown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.hide();
        return;
      }

      if (event.key === "Tab") {
        this.trapFocus(event);
      }
    },

    trapFocus(event) {
      const dialog = this.$refs.dialog;
      if (!dialog) return;

      const focusables = dialog.querySelectorAll(FOCUSABLE);
      if (focusables.length === 0) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }));
}
